import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { getAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";

export const getCJWDIUploadHistory = async (params) => {

    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }

    const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwDiUploadHistory}`;

    const response = await getAPI(apiUrl, tokenInfo);

    if (response.status === 200 || response.status === 201) {
        return response.json();
    } else {
        const errorData = await response.json();
        response.status !== 200 ? AlertManager.error(errorData.message, {contactSupport: false}) : AlertManager.error(response.statusText, {ContactSupport: false});
        return { content: [], totalPages: 0 };
    }

};
